import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Dev-only: the CRA error overlay treats the benign browser notice "ResizeObserver loop completed with undelivered
// notifications" as an uncaught runtime error. Swallow ONLY that exact message (capture phase, before the overlay's
// window listener); every other error, React error and API error still surfaces normally. No effect in production builds.
if (process.env.NODE_ENV === 'development') {
  const isBenignResizeObserverNotice = (msg) => typeof msg === 'string' && /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/.test(msg);
  window.addEventListener('error', (e) => {
    if (isBenignResizeObserverNotice(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
